import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const tasks = [
    'Анализ последствий переезда,',
    ' Выдвижение гипотез по устранению проблем,',
    'Разработка стратегии на основе гипотез и ее реализация,',
    ' Поиск новых точек роста трафика для проекта.',
];

const UkassaTasks = () => {
    return (
        <div className="ukassa-tasks">
            <div className="ukassa-tasks__big-ball" />
            <ScrollAnimation
                delay={0}
                animateIn="fadeIn"
                offset={100}
                animateOnce={true}
                duration={1}
            >
                <FullWrapper bigPaddings isMargin={false}>
                    <div className="ukassa-tasks__wrap">
                        <span className="ukassa-tasks__title">Задачи:</span>
                        <div className="ukassa-tasks__list">
                            {tasks.map((text, index) => {
                                return (
                                    <div className="ukassa-tasks__item" key={index}>
                                        <span>{`${index + 1}.`}</span>
                                        {text}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
            <div className="ukassa-tasks__small-ball" />
        </div>
    );
};

export default UkassaTasks;
